export const API_URLS_COMMON = {
  LOGIN: "User/Login",
  FORGOT_PASSWORD: "User/ForgotPassword",
  VALIDATE_RESET_PASSWORD_LINK: "User/ValidateResetPasswordLink",
  RESET_PASSWORD: "User/ResetPassword",
  TOKEN_INFO: "User/TokenInfo",
};
